import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import ReduxPromise from "redux-promise";
import ReduxThunk from "redux-thunk";

// eslint-disable-next-line no-unused-vars
import registerServiceWorker, { unregister as unregisterServiceWorker } from "./registerServiceWorker";

import "./index.css";
import App from "./App";
import reducers from "./reducers";

// import polyfills
require("babel-polyfill");

const middlewares = [ReduxPromise, ReduxThunk];

const composeEnhancers =
    // window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ||
    compose;

const store = createStore(reducers, composeEnhancers(applyMiddleware(...middlewares)));

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById("root")
);

// registerServiceWorker();
unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js